import { create } from "zustand";

import type { SubscriptionStatus, UserPermissions } from "common/types";

import type { Location } from "react-router-dom";

interface DebugOptions {
  shouldDebugLogin: boolean;
  isPaymentMethodHidden: boolean;
  isWithoutSubscription: boolean;
  isWithoutRentedSubscription: boolean;
  isWithoutAccounts: boolean;
  subscriptionStatus: SubscriptionStatus;
  rentedSubscriptionStatus: Exclude<SubscriptionStatus, "in_trial">;
  workspacePermissions: UserPermissions;
}
interface AppState {
  isCampaignModalOpen: boolean;
  setIsCampaignModalOpen: (isCampaignModalOpen: boolean) => void;

  debugOptions: DebugOptions;
  setDebugOptions: (debugOptions: Partial<DebugOptions>) => void;

  previousLocation: Location | null;
  setPreviousLocation: (previousLocation: Location) => void;
}
export default create<AppState>((set, get) => ({
  isCampaignModalOpen: false,
  setIsCampaignModalOpen: (isCampaignModalOpen) => set({ isCampaignModalOpen }),

  debugOptions: {
    shouldDebugLogin: false,
    isWithoutSubscription: false,
    isWithoutRentedSubscription: false,
    isWithoutAccounts: false,
    isPaymentMethodHidden: false,
    subscriptionStatus: null,
    rentedSubscriptionStatus: null,
    workspacePermissions: null,
  },
  setDebugOptions: (newDebugOptions) =>
    set({ debugOptions: { ...get().debugOptions, ...newDebugOptions } }),

  previousLocation: null,
  setPreviousLocation: (previousLocation: Location) =>
    set({ previousLocation }),
}));
